import {
  Button,
  ContentSection,
  CountBadge,
  EmptyState,
  Illustration
} from '@sollapay/ui/components';
import {SearchIllustration} from '@sollapay/ui/illustrations';
import {useTranslation} from 'react-i18next';

import {BuyerPaymentHistoryTable} from './BuyerPaymentHistoryTable';

import type {BuyerDTO, PaymentInstructionDTO} from '@sollapay/types';
import type {FC} from 'react';

export interface BuyerPaymentHistorySectionProps {
  instructions: PaymentInstructionDTO[];
  assetLabel: string;
  buyersById: Map<string, BuyerDTO>;
  onRequestPayment?: () => void;
  requestPaymentDisabled?: boolean;
  onResend?: (instruction: PaymentInstructionDTO) => void;
  onCancel?: (instruction: PaymentInstructionDTO) => void;
  onViewBuyer?: (buyerId: string) => void;
}

export const BuyerPaymentHistorySection: FC<BuyerPaymentHistorySectionProps> = ({
  instructions,
  assetLabel,
  buyersById,
  onRequestPayment,
  requestPaymentDisabled = false,
  onResend,
  onCancel,
  onViewBuyer
}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <ContentSection
      title={t('view.buyers.detail.paymentHistory')}
      titleBadge={<CountBadge count={instructions.length} />}
      action={
        onRequestPayment && !requestPaymentDisabled ? (
          <Button variant="primary" size="sm" onClick={onRequestPayment}>
            {t('view.buyers.detail.actions.sendPaymentRequest')}
          </Button>
        ) : undefined
      }
    >
      <BuyerPaymentHistoryTable
        instructions={instructions}
        buyersById={buyersById}
        onResend={onResend}
        onCancel={onCancel}
        onViewBuyer={onViewBuyer}
        emptyState={
          <EmptyState
            className="py-8"
            illustration={
              <Illustration width={64} height={50}>
                <SearchIllustration />
              </Illustration>
            }
            title={t('view.buyers.detail.emptyPayments.title')}
            subtitle={t('view.buyers.detail.emptyPayments.description', {
              asset: assetLabel
            })}
          />
        }
      />
    </ContentSection>
  );
};
